<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4 menu-side-left">
    <!-- Brand Logo -->
    <a href="index3.html" class="brand-link" style="opacity: 0">
      <img src="/favicon.png" alt="Yescar Logo" class="brand-image img-circle elevation-3" style="opacity: 0.8" />
      <!-- <span class="brand-text font-weight-light">AdminLTE 3</span> -->
    </a>

    <!-- Sidebar -->
    <div class="sidebar overide-font" style="height: calc(97% - (3.5rem + 15px))">
      <!-- Sidebar Menu -->
      <nav>
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
          <MenuItem
            v-for="(item, index) in internalMenu"
            :title="item.title"
            :icon-class="item.icon"
            :icon="item.icon"
            :badge="item.badge"
            :selected="item.selected"
            :iconComponent="item.iconComponent"
            :children="item.children"
            :children-level="0"
            :is-open="item.isOpen"
            @handle-click-menu="toggleMenu"
            :is-collapsing="item.isCollapsing"
            :path="item.path"
            :permission="item.permission"
            :key="item.path || `${keyList}${index.toString()}`"
          />
        </ul>
      </nav>

      <!-- /.sidebar-menu -->
    </div>
    <div class="sidebar-footer-link">
      <a :href="websiteUrl" target="_blank" rel="noopener noreferrer" class="website-nav-link">
        <span>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Solid Blue Circle -->
            <circle cx="12" cy="12" r="10" fill="#0a68fe" />
            <!-- Gold Globe Lines -->
            <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="#ffcc00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.1 10h19.8M2.1 14h19.8" stroke="#ffcc00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Website
        </span>
      </a>
    </div>
  </aside>
</template>
<script>
  import { PERMISSION } from '@/constants/permission.constant';
  import { mapActions, mapGetters } from 'vuex';
  import MenuItem from './MenuItem.vue';

  export default {
    name: 'AppSideBar',
    props: { menuItems: [] },
    components: { MenuItem },
    data() {
      return {
        keyList: this.$udid(),
        menuOpen: '',
        permissionsList: [],
        PERMISSION,
        isCollapsing: null,
        internalMenu: [],
        activePath: null,
        websiteUrl: process.env.VUE_APP_WEB_URL,
      };
    },
    computed: {
      ...mapGetters('menuStore', ['activeMenuItem']),
      ...mapGetters('inboxSummary', ['getBuyUnreadCount', 'getSellUnreadCount', 'getAfterServiceUnreadCount', 'getInboxTotal']),
    },
    methods: {
      applyInboxBadges() {
        const inboxMenu = this.internalMenu.find((m) => m.keyId === 'inbox');
        if (!inboxMenu) return;

        const buy = inboxMenu.children.find((c) => c.keyId === 'inbox-buy-car');
        const sell = inboxMenu.children.find((c) => c.keyId === 'inbox-sell-car');
        const after = inboxMenu.children.find((c) => c.keyId === 'inbox-after-sales');

        if (buy) buy.badge = this.getBuyUnreadCount;
        if (sell) sell.badge = this.getSellUnreadCount;
        if (after) after.badge = this.getAfterServiceUnreadCount;

        // Total badge on parent menu
        inboxMenu.badge = this.getInboxTotal;
      },

      ...mapActions('menuStore', ['setActiveMenuItem']),
      toggleMenu(v) {
        // this.menuOpen = v;
        // this.setActiveMenuItem(v);
      },

      // Reset all selected states to false
      resetAllSelected(menuItems) {
        return menuItems.map((item) => {
          const resetItem = { ...item, selected: false };
          if (item.children && item.children.length > 0) {
            resetItem.children = this.resetAllSelected(item.children);
          }
          return resetItem;
        });
      },

      // Recursive function to check and update menu items
      checkAndUpdateMenuItems(menuItems, currentPath) {
        // First reset all selected states
        const resetMenu = this.resetAllSelected(menuItems);

        // Then update based on current path
        return resetMenu.map((menuItem) => {
          // Check if current path matches menu item path
          const isPathMatch = currentPath.indexOf(menuItem.path) > -1;
          // console.log(currentPath, menuItem.path);

          // If menu has children, recursively check them
          if (menuItem.children && menuItem.children.length > 0) {
            const updatedChildren = this.checkAndUpdateMenuItems(menuItem.children, currentPath);
            const hasMatchingChild = updatedChildren.some((child) => child.selected);

            return {
              ...menuItem,
              children: updatedChildren,
              selected: isPathMatch || hasMatchingChild,
            };
          }

          // Return menu item with updated selected state
          return {
            ...menuItem,
            selected: isPathMatch,
          };
        });
      },

      async fetchLatestData() {
        await this.$store.dispatch('userPermission/getPermissionsUsers');
      },

      setMenuActived() {
        const to = this.$route?.path;
        if (!to) return;

        // Clear all active states first
        this.clearOpenAndActivedAll();

        // Get path segments after domain
        const pathSegments = to.split('/').filter((segment) => segment !== '');

        // Find and activate parent menu
        const parentPath = `/${pathSegments[0]}`;
        const parentMenu = this.menuItems.find((item) => item.path === parentPath);

        if (parentMenu) {
          this.menuOpen = parentMenu.title;
          this.setActiveMenuItem(parentMenu.title);

          // If there are children, find and activate the child menu
          if (pathSegments.length > 1 && parentMenu.children) {
            const childPath = `/${pathSegments.join('/')}`;
            const childMenu = parentMenu.children.find((item) => item.path === childPath);
            if (childMenu) {
              this.activePath = childPath;
            }
          }
        }
      },

      clearOpenAndActivedAll() {
        document.querySelectorAll('ul.nav-sidebar li.nav-item').forEach((el) => {
          el.classList.remove('menu-is-opening', 'menu-open');
          const treeView = el.querySelector(`a.nav-link+ul.nav-treeview`);
          if (treeView) {
            treeView.style.display = 'none';
          }
        });
      },
    },
    watch: {
      getBuyUnreadCount: 'applyInboxBadges',
      getSellUnreadCount: 'applyInboxBadges',
      getAfterServiceUnreadCount: 'applyInboxBadges',
      getInboxTotal: 'applyInboxBadges',
      $route: {
        handler(to, from) {
          // Update menu items using recursive function
          this.internalMenu = this.checkAndUpdateMenuItems(this.menuItems, to.path);
          // console.log({ list: this.internalMenu });
          this.applyInboxBadges();
        },
        deep: true,
      },
      menuItems: {
        handler(v1, v0) {
          this.internalMenu = this.checkAndUpdateMenuItems(v1, this.$route.path);
          this.applyInboxBadges();
        },
        deep: true,
      },
    },
    async mounted() {
      this.internalMenu = this.checkAndUpdateMenuItems(this.menuItems, this.$route.path);

      this.applyInboxBadges();
    },
    created() {
      // Start the interval when the sidebar is created
      this.$store.dispatch('inboxSummary/initInboxSummary');
      this.fetchLatestData();
    },

    beforeDestroy() {
      // Stop the interval when sidebar is destroyed
      this.$store.dispatch('inboxSummary/destroyInboxSummary');
    },
  };
</script>
<style scoped>
  .dynamic-sidebar-height {
    height: calc(95% - (3.5rem + 15px));
  }

  @media (min-height: 850px) {
    .dynamic-sidebar-height {
      height: calc(99% - (3.5rem + 15px));
    }
  }

  .sidebar-footer-link {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: inherit;
  }

  .website-nav-link {
    display: block;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.9);
    padding: 4px 4px;
    border-radius: 4px;
    background-color: #f0f5fecf;
    line-height: 1.5;
    font-size: 14px;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
  }

  .website-nav-link span {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-left: 20px;
  }

  .website-nav-link:hover {
    background-color: #e2ecf9;
    color: #2e7efe;
    text-decoration: none;
  }
</style>
